import React, { useEffect, useState, useRef } from 'react';
import { connect, history } from 'umi';
import { isEmpty } from 'lodash';

import { Form } from 'antd';
import classNames from 'classnames';

import Header from '@/components/Header';
import BasicBaseSpin from '@/components/BasicBaseSpin';
import { Clickable } from '@/components';
import useGCPI18n from '@/hooks/useGCPI18n';
import { onHistoryPush, formatDateNew } from '@/utils/utils';
import { C2C_FONT_FAMILY } from '@/utils/constants';
import giftPng from '@/assets/images/postPaidC2C/gift.png';
import chevRight from '@/assets/images/postPaidC2C/chev-right.svg';
import { RewardClaimDialogs } from '../components/RewardClaimDialog';
import useRewardClaimFlow from '../hooks/useRewardClaimFlow';
import useRewardClaimOptions from '../hooks/useRewardClaimOptions';
import useRewardListScroll from '../hooks/useRewardListScroll';

import styles from './index.less';

const PostPaidC2CHistory = props => {
  const GCPI18n = useGCPI18n();
  const [form] = Form.useForm();
  const { activityDetail = {}, isManual, gameCode, pageRenderDetail, loading, dispatch } = props;
  const [pageNum, setPageNum] = useState(1);
  const [listTotal, setListTotal] = useState(0);
  const [rewardList, setRewardList] = useState([]);
  const containerRef = useRef(null);

  // const { promotionId } = JSON.parse(localStorage.getItem('promotionId')) || {};
  const { mainColor, auxiliaryColor } = pageRenderDetail || {};
  const { chooseSubNumMethod, subNumType, promotionId } = activityDetail || {};
  const pageFontFamily = C2C_FONT_FAMILY?.[pageRenderDetail?.fontFamily];
  const { phoneRegex, serviceNumberList } = useRewardClaimOptions({
    dispatch,
    chooseSubNumMethod,
    subNumType,
  });

  const rewardListRef = useRef(rewardList);
  const listTotalRef = useRef(listTotal);
  const isSpecificTime = true;

  // 更新 ref 的值
  useEffect(() => {
    rewardListRef.current = rewardList;
    listTotalRef.current = listTotal;
  }, [rewardList, listTotal]);

  const handleListQry = async value => {
    const res = await dispatch({
      type: 'postPaidC2c/qryInviteeListDXP',
      payload: {
        gameCode,
        pageIndex: value?.pageNum || pageNum,
        pageSize: '100',
      },
    });
    const { pageInfo = {}, data } = res || {};
    const { inviteeList: list } = data || {};
    if (!listTotal || listTotal !== pageInfo.total) {
      setListTotal(pageInfo.total);
    }
    if (pageInfo.currentPage > 1) {
      setRewardList([...(rewardList || []), ...(list || [])]);
    } else {
      setRewardList(list);
    }
  };

  const handlePageNumChange = () => {
    setPageNum(pageNum + 1);
    handleListQry({
      pageNum: pageNum + 1,
    });
  };

  const claimFlow = useRewardClaimFlow({
    form,
    dispatch,
    chooseSubNumMethod,
    pageRenderDetail,
    refreshAfterClaim: () => {
      setPageNum(1);
      handleListQry({
        pageNum: 1,
      });
    },
  });

  useRewardListScroll({
    containerRef,
    listRef: rewardListRef,
    totalRef: listTotalRef,
    onReachBottom: handlePageNumChange,
  });

  const renderRewardClaimInfo = claimDetail => {
    const { invitationStatus } = claimDetail || {};
    const { rewardName, state, receiveDeadDate, isManualClaim } = claimDetail?.rewardList[0] || {};
    return (
      <div className={styles.claim}>
        <div className={styles.left}>
          <span className={styles.name}>{rewardName}</span>
          <span className={styles.invitationStatus}>{invitationStatus}</span>
          {receiveDeadDate && (
            <span className={styles.time}>
              {GCPI18n('lb_post_paid_claim_before')}{' '}
              {formatDateNew(receiveDeadDate, isSpecificTime)}
            </span>
          )}
        </div>
        {/* <div className={`${styles.right} ${className}`} onClick={() => handleClaimed(claimDetail, rewardDetail)}> */}
        {state === 'A' && (
          <Clickable
            className={styles.rightA}
            style={{ backgroundColor: mainColor }}
            onClick={() => claimFlow.handleClaimReward(claimDetail?.rewardList[0] || {})}
          >
            <span>{pageRenderDetail?.claimRewardButtonText}</span>
          </Clickable>
        )}
        {state === 'B' && (isManual === 'Y' || isManualClaim) && (
          <div className={styles.rightB}>
            <span>{GCPI18n('lb_post_paid_claimed')}</span>
          </div>
        )}
        {state === 'E' && (
          <div className={styles.rightE}>
            <span>{GCPI18n('lb_post_paid_expired')}</span>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    // 查询列表
    if (promotionId) {
      handleListQry();
    }
  }, [promotionId]);

  return (
    <div className={styles.pageWrap} style={{ fontFamily: pageFontFamily }}>
      <BasicBaseSpin spinning={loading} size="large">
        <Header
          title="My Referral"
          titleColor="#3E3E3E"
          titleFontFamily={pageFontFamily}
          goBack={() => history.goBack()}
          hideGoHome
        />
        <div className={styles.contain}>
          <div className={styles.listBox} ref={containerRef}>
            {isEmpty(rewardList) && !loading ? (
              <div className={styles.noData}>
                <img src={giftPng} alt="" />
                <div className={styles.tip}>{pageRenderDetail?.emptyStateMessage}</div>
              </div>
            ) : (
              <div className={styles.rewardList}>
                {(rewardList || []).map((reward, i) => {
                  // const { text, color } = getCurrentState(reward);
                  const {
                    custName,
                    createdDate,
                    updateDate,
                    invitationStatus,
                    invitationStatusCSS,
                    actionList,
                    promReferInstId,
                  } = reward || {};
                  const colorMatch = invitationStatusCSS?.match(/#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})/);
                  const curStatusColor = colorMatch && colorMatch[0] ? colorMatch[0] : null;

                  return (
                    <div className={styles.rewardInfo} key={`${custName}_${i}`}>
                      <div className={styles.nameBox}>
                        <div>{custName}</div>
                        <Clickable
                          onClick={() => {
                            dispatch({
                              type: 'postPaidC2c/save',
                              payload: { selectedCustName: custName },
                            });
                            onHistoryPush('/postPaidC2CDetail', {
                              promReferInstId,
                            });
                          }}
                        >
                          <img src={chevRight} alt="" />
                        </Clickable>
                      </div>
                      <div
                        className={classNames(
                          styles.itemBox,
                          !isEmpty(actionList) ? styles.noLine : styles.noPadding,
                        )}
                      >
                        <div className={styles.item}>
                          <div className={styles.label}>{GCPI18n('lb_common_created_date')}</div>
                          <div className={styles.value}>
                            {formatDateNew(createdDate, isSpecificTime)}
                          </div>
                        </div>
                        <div className={styles.item}>
                          <div className={styles.label}>
                            {GCPI18n('lb_common_last_update_date')}
                          </div>
                          <div className={styles.value}>
                            {formatDateNew(updateDate, isSpecificTime)}
                          </div>
                        </div>
                        {invitationStatus && (
                          <div className={styles.item}>
                            <div className={styles.label}>
                              {GCPI18n('lb_post_paid_invitation_status')}
                            </div>
                            <div className={styles.value} style={{ color: curStatusColor }}>
                              {invitationStatus}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className={styles.claimList}>
                        {(actionList || []).map(event => renderRewardClaimInfo(event))}
                      </div>
                    </div>
                  );
                })}
                {rewardList.length === listTotal && (
                  <div className={styles.allTip}>{GCPI18n('lb_post_paid_keep_tips')}</div>
                )}
              </div>
            )}
          </div>
        </div>
      </BasicBaseSpin>
      <RewardClaimDialogs
        claimFlow={claimFlow}
        styles={styles}
        form={form}
        pageFontFamily={pageFontFamily}
        pageRenderDetail={pageRenderDetail}
        chooseSubNumMethod={chooseSubNumMethod}
        serviceNumberList={serviceNumberList}
        phoneRegex={phoneRegex}
        mainColor={mainColor}
        GCPI18n={GCPI18n}
        closeStyle={{ color: auxiliaryColor }}
      />
    </div>
  );
};

export default connect(({ index, loading }) => ({
  pageRenderDetail: index.pageRenderDetail,
  activityDetail: index.activityDetail,
  isManual: index.isManual,
  gameCode: index.gameCode,
  loading:
    loading.effects['postPaidC2c/qryInviteeListDXP'] ||
    loading.effects['myAwards/claimRewardDXP'] ||
    loading.effects['postPaidC2c/receiveReward'] ||
    false,
}))(PostPaidC2CHistory);
